

export const stringifyCreationHistoryForBeacon = (creationHistory: string[]) => JSON.stringify([...creationHistory].reverse().map(
    creation => creation.split('|').reverse()
))
